import { actionLoadingStates } from "./stateEnums";
import type { ActionLoadingState } from "./stateEnums";

export const isLoading = (
  loadingState: ActionLoadingState | undefined,
): boolean => {
  return loadingState === actionLoadingStates.pending;
};

export const hasLoaded = (
  loadingState: ActionLoadingState | undefined,
): boolean => {
  const loadedStates: ActionLoadingState[] = [
    actionLoadingStates.succeeded,
    actionLoadingStates.failed,
  ];
  return loadingState !== undefined && loadedStates.includes(loadingState);
};
